module.exports = __webpack_public_path__ + "static/media/AboutUs-Service-Main.baac08dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/expresonorte/about-us/AboutUs-Service-Main.jpg
// module id = 1143
// module chunks = 0